import { render, staticRenderFns } from "./Remotekey.vue?vue&type=template&id=5f13fe64"
import script from "./Remotekey.vue?vue&type=script&lang=js"
export * from "./Remotekey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports